export class PartnerSearchSettings {
    constructor(
        public searchString = '',
        public extendedSearch = false,
        public includeLatesDocumentDate = false,
        public searchTags = [] as number[],
        public onlyProxyPartners = false,
        public skipMaxSearchResult = false,
        public includePartnerOnboarding = false,
        public allPartnerOnboarding = false,
    ) {
    }
}
